import React from 'react';
import { cx } from 'emotion';
import { id } from '../../utils';

export default function Radio({ className, ...props }) {
  return (
    <input type="radio" className={cx(id('radio'), className)} {...props} />
  );
}
